import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { UpdateResellerBlockStatusParams } from "./updateResellerBlockStatus.types";

export const requestUpdateResellerBlockStatus = async ({
  resellerId,
  action,
  reason
}: UpdateResellerBlockStatusParams): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesResellers.Reseller, resellerId, action),
    { reason }
  );
};
